import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsmAuthStorageService, TokenTarget } from '@spartacus/asm/root';
import { UserIdService } from '@spartacus/core';
import { combineLatest, Observable, of, switchMap, take } from 'rxjs';
import { REMOVE_AUTH_HEADER } from '../../../../core/remove-auth-header';

@Injectable({ providedIn: 'root' })
export class AsmBlockInvalidRequestInterceptor implements HttpInterceptor {
  constructor(
    private userIdService: UserIdService,
    private asmAuthStorageService: AsmAuthStorageService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return combineLatest([this.userIdService.isEmulated(), this.asmAuthStorageService.getTokenTarget()]).pipe(
      take(1),
      switchMap(([isEmulated, tokenTarget]) => {
        const anonymousRequest = req.headers.has(REMOVE_AUTH_HEADER);
        const currentUserRequest = /\/users\/current\//.test(req.url);
        if (
          currentUserRequest &&
          !anonymousRequest &&
          !this.isWhoAmIRequest(req.url) &&
          (isEmulated || tokenTarget === TokenTarget.CSAgent)
        ) {
          return of(null);
        }
        return next.handle(req);
      })
    );
  }

  private isWhoAmIRequest(url: string): boolean {
    return url.indexOf('whoAmI') > 0;
  }
}
